"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Story() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduced: "(prefers-reduced-motion: reduce)",
      normal: "(prefers-reduced-motion: no-preference)"
    }, context => {
      const {
        reduced
      } = context.conditions as {
        reduced: boolean;
      };
      if (reduced) {
        gsap.set([".mf-eyebrow", ".mf-line", ".mf-divider", ".mf-meta"], {
          opacity: 1,
          y: 0,
          width: "auto"
        });
        gsap.set(".mf-divider", {
          width: 40
        });
        return;
      }
      gsap.from(".mf-eyebrow", {
        opacity: 0,
        y: 16,
        duration: 0.55,
        ease: "power3.out",
        scrollTrigger: {
          trigger: container.current,
          start: "top 75%"
        }
      });
      gsap.from(".mf-line", {
        opacity: 0,
        y: 40,
        duration: 0.7,
        stagger: 0.09,
        ease: "power3.out",
        delay: 0.22,
        scrollTrigger: {
          trigger: container.current,
          start: "top 75%"
        }
      });
      gsap.from(".mf-divider", {
        width: 0,
        duration: 0.5,
        ease: "power2.out",
        delay: 0.95,
        scrollTrigger: {
          trigger: container.current,
          start: "top 75%"
        }
      });
      gsap.from(".mf-meta", {
        opacity: 0,
        y: 10,
        duration: 0.5,
        ease: "power3.out",
        delay: 1.05,
        scrollTrigger: {
          trigger: container.current,
          start: "top 75%"
        }
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="24109" id="our-story" data-nav="light" className="bg-background py-32 md:py-44">
      <div ref={container} className="mx-auto max-w-[1240px] px-6 md:px-10">
        <div className="mx-auto w-full md:w-8/12">
          <div className="flex justify-start md:justify-center">
            <span className="mf-eyebrow inline-flex items-center rounded-lg bg-accent px-4 py-2 text-xs font-semibold uppercase tracking-[0.08em] text-accent-foreground">
              Our mission
            </span>
          </div>

          <h2 className="mt-8 text-left font-serif font-extrabold text-foreground" style={{
          fontSize: "clamp(2.25rem, 6.8vw, 6rem)",
          letterSpacing: "-0.03em",
          lineHeight: 0.95
        }}>
            <span className="mf-line block overflow-hidden">
              <span className="block">We believe</span>
            </span>
            <span className="mf-line block overflow-hidden">
              <span className="block">that every small act</span>
            </span>
            <span className="mf-line block overflow-hidden">
              <span className="block italic text-secondary">of love and light</span>
            </span>
            <span className="mf-line block overflow-hidden">
              <span className="block italic text-secondary">can change</span>
            </span>
            <span className="mf-line block overflow-hidden">
              <span className="block">the world for the better.</span>
            </span>
          </h2>

          <div className="mt-10 flex flex-col items-start gap-5">
            <span className="mf-divider block h-px bg-foreground" style={{
            width: 40
          }} aria-hidden="true" />
            <p className="mf-meta text-sm font-medium tracking-[0.01em] text-muted-foreground">
              Victoria Light Foundation
            </p>
          </div>
        </div>
      </div>
    </section>;
}